export default __webpack_public_path__ + "static/media/Slide_1.09c087e3.jpeg";